// extracted by mini-css-extract-plugin
module.exports = {"table":"past-day-modal_table__2o7U6","temperature":"past-day-modal_temperature__13D_l"};